import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductSubcategoryRoutingModule } from './product-subcategory-routing.module';
import { ProductSubcategoryComponent } from './product-subcategory/product-subcategory.component';
import { ProductSubcategoryDataComponent } from './product-subcategory-data/product-subcategory-data.component';
import { ProductSubcategoryDataTableComponent } from './product-subcategory-data-table/product-subcategory-data-table.component';
import { ProductSubcategoryDeleteDialogComponent } from './product-subcategory-delete-dialog/product-subcategory-delete-dialog.component';
import { ProductSubcategoryAddDialogComponent } from './product-subcategory-add-dialog/product-subcategory-add-dialog.component';
import { ProductSubcategoryEditDialogComponent } from './product-subcategory-edit-dialog/product-subcategory-edit-dialog.component';
import { ProductSubcategoryHeaderComponent } from './product-subcategory-header/product-subcategory-header.component';

import { NavbarModule } from '../navbar/navbar.module';
import { ToolbarModule } from '../toolbar/toolbar.module';
import { TranslateModule } from '@ngx-translate/core';
import { LoadingModule } from '../loading/loading.module';
import { SharedModule } from '../shared/shared.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';

@NgModule({
  declarations: [
    ProductSubcategoryComponent,
    ProductSubcategoryDataComponent,
    ProductSubcategoryDataTableComponent,
    ProductSubcategoryDeleteDialogComponent,
    ProductSubcategoryAddDialogComponent,
    ProductSubcategoryEditDialogComponent,
    ProductSubcategoryHeaderComponent,
  ],
  imports: [
    CommonModule,
    ProductSubcategoryRoutingModule,
    NavbarModule,
    ToolbarModule,
    TranslateModule,
    LoadingModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatTableModule,
    MatMenuModule,
    MatDialogModule,
    MatCheckboxModule,
  ],
})
export class ProductSubcategoryModule {}
